module.exports = __webpack_public_path__ + "img/m-nex25-back.7da64c2d.jpg";